export class RestLocalCache {
    getInitialStore() {
        return {
            results: {},
            awaitingKeys: [],
        };
    }
    static getInstance() {
        if (!RestLocalCache.instance) {
            RestLocalCache.instance = new RestLocalCache();
            if (typeof window !== "undefined" && !window.fetchCache) {
                window.fetchCache = RestLocalCache.instance.getInitialStore();
            }
        }
        return RestLocalCache.instance;
    }
    registerAction(key) {
        window.fetchCache.awaitingKeys.push(key);
    }
    unregisterAction(key) {
        window.fetchCache.awaitingKeys = window.fetchCache.awaitingKeys.filter((item) => item !== key);
    }
    setValue(key, value, success = true) {
        window.fetchCache.results[key] = {
            value,
            success,
        };
        window.fetchCache.awaitingKeys = window.fetchCache.awaitingKeys.filter((currentKey) => currentKey !== key);
    }
    getValue(key, onError) {
        return new Promise((resolve, reject) => {
            const interval = setInterval(() => {
                if (window.fetchCache.awaitingKeys.indexOf(key) === -1) {
                    const currentValue = window.fetchCache.results[key];
                    clearInterval(interval);
                    if (!currentValue) {
                        return onError(resolve, reject);
                    }
                    if (currentValue.success) {
                        resolve(currentValue.value);
                    }
                    else {
                        reject(currentValue.value);
                    }
                }
            }, 100);
        });
    }
    hasValue(key) {
        return window.fetchCache.awaitingKeys.indexOf(key) > -1 || !!window.fetchCache.results[key];
    }
    clear() {
        window.fetchCache = this.getInitialStore();
    }
}
//# sourceMappingURL=RestLocalCache.js.map